module.exports = __webpack_public_path__ + "img/big-cross.b0c5ad42.svg";